
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Playground, Props } from 'docz'
import { State, Toggle } from 'react-powerplug'
import FormFieldMultipleInputs from './form-field-multiple-inputs'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "formfieldmultipleinputs"
    }}>{`FormFieldMultipleInputs`}</h1>
    <p><strong parentName="p">{`SUBCATEGORY:`}</strong>{` Forms`}</p>
    <hr />
    <h2 {...{
      "id": "multiple-input-fields"
    }}>{`Multiple input fields`}</h2>
    <h3 {...{
      "id": "description"
    }}>{`Description`}</h3>
    <p>{`For multiple single lines of text, such as a mailing address.`}</p>
    <Playground __position={1} __code={'<State\n  initial={{\n    fields: {\n      11: {\n        value: \'\',\n        ariaLabel: \'Label 1\',\n        id: \'11\',\n      },\n      12: {\n        value: \'\',\n        ariaLabel: \'Label 2\',\n        id: \'12\',\n      },\n    },\n  }}\n>\n  {({ state, setState }) => (\n    <FormFieldMultipleInputs\n      {...state}\n      labelText=\"Label\"\n      onChange={e =>\n        setState({\n          fields: {\n            ...state.fields,\n            [e.target.id]: {\n              ...state.fields[e.target.id],\n              value: e.target.value,\n            },\n          },\n        })\n      }\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      Toggle,
      FormFieldMultipleInputs
    }} mdxType="Playground">
  <State initial={{
        fields: {
          11: {
            value: '',
            ariaLabel: 'Label 1',
            id: '11'
          },
          12: {
            value: '',
            ariaLabel: 'Label 2',
            id: '12'
          }
        }
      }} mdxType="State">
    {({
          state,
          setState
        }) => <FormFieldMultipleInputs {...state} labelText='Label' onChange={e => setState({
          fields: { ...state.fields,
            [e.target.id]: { ...state.fields[e.target.id],
              value: e.target.value
            }
          }
        })} mdxType="FormFieldMultipleInputs" />}
  </State>
    </Playground>
    <hr />
    <h2 {...{
      "id": "multiple-input-fields-different-types"
    }}>{`Multiple input fields (different types)`}</h2>
    <h3 {...{
      "id": "description-1"
    }}>{`Description`}</h3>
    <p>{`For multiple, single input fields of different types, such as number, date, password, text and email.`}</p>
    <Playground __position={3} __code={'<State\n  initial={{\n    fields: {\n      11: {\n        value: \'\',\n        ariaLabel: \'Label 1\',\n        id: \'11\',\n        type: \'date\',\n      },\n      12: {\n        value: \'\',\n        ariaLabel: \'Label 2\',\n        id: \'12\',\n        type: \'number\',\n      },\n    },\n  }}\n>\n  {({ state, setState }) => (\n    <FormFieldMultipleInputs\n      {...state}\n      labelText=\"Label\"\n      onChange={e =>\n        setState({\n          fields: {\n            ...state.fields,\n            [e.target.id]: {\n              ...state.fields[e.target.id],\n              value: e.target.value,\n            },\n          },\n        })\n      }\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      Toggle,
      FormFieldMultipleInputs
    }} mdxType="Playground">
  <State initial={{
        fields: {
          11: {
            value: '',
            ariaLabel: 'Label 1',
            id: '11',
            type: 'date'
          },
          12: {
            value: '',
            ariaLabel: 'Label 2',
            id: '12',
            type: 'number'
          }
        }
      }} mdxType="State">
    {({
          state,
          setState
        }) => <FormFieldMultipleInputs {...state} labelText='Label' onChange={e => setState({
          fields: { ...state.fields,
            [e.target.id]: { ...state.fields[e.target.id],
              value: e.target.value
            }
          }
        })} mdxType="FormFieldMultipleInputs" />}
  </State>
    </Playground>
    <hr />
    <h2 {...{
      "id": "multiple-input-fields-placeholder"
    }}>{`Multiple input fields (placeholder)`}</h2>
    <h3 {...{
      "id": "description-2"
    }}>{`Description`}</h3>
    <p>{`For multiple single lines of text, such as a mailing address.`}</p>
    <Playground __position={5} __code={'<State\n  initial={{\n    fields: {\n      31: {\n        value: \'\',\n        ariaLabel: \'Label 1\',\n        id: \'31\',\n        placeholder: \'Text placeholder\',\n      },\n      32: {\n        value: \'\',\n        ariaLabel: \'Label 2\',\n        id: \'32\',\n        placeholder: \'Text placeholder\',\n      },\n    },\n  }}\n>\n  {({ state, setState }) => (\n    <FormFieldMultipleInputs\n      {...state}\n      labelText=\"Label\"\n      onChange={e =>\n        setState({\n          fields: {\n            ...state.fields,\n            [e.target.id]: {\n              ...state.fields[e.target.id],\n              value: e.target.value,\n            },\n          },\n        })\n      }\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      Toggle,
      FormFieldMultipleInputs
    }} mdxType="Playground">
  <State initial={{
        fields: {
          31: {
            value: '',
            ariaLabel: 'Label 1',
            id: '31',
            placeholder: 'Text placeholder'
          },
          32: {
            value: '',
            ariaLabel: 'Label 2',
            id: '32',
            placeholder: 'Text placeholder'
          }
        }
      }} mdxType="State">
    {({
          state,
          setState
        }) => <FormFieldMultipleInputs {...state} labelText='Label' onChange={e => setState({
          fields: { ...state.fields,
            [e.target.id]: { ...state.fields[e.target.id],
              value: e.target.value
            }
          }
        })} mdxType="FormFieldMultipleInputs" />}
  </State>
    </Playground>
    <hr />
    <h2 {...{
      "id": "multiple-input-fields-helper"
    }}>{`Multiple input fields (helper)`}</h2>
    <h3 {...{
      "id": "description-3"
    }}>{`Description`}</h3>
    <p>{`For multiple single lines of text, such as a mailing address.`}</p>
    <Playground __position={7} __code={'<State\n  initial={{\n    fields: {\n      41: {\n        value: \'\',\n        ariaLabel: \'Label 1\',\n        id: \'41\',\n      },\n      42: {\n        value: \'\',\n        ariaLabel: \'Label 2\',\n        id: \'42\',\n      },\n    },\n  }}\n>\n  {({ state, setState }) => (\n    <FormFieldMultipleInputs\n      {...state}\n      helperText=\"Helper text\"\n      labelText=\"Label\"\n      onChange={e =>\n        setState({\n          fields: {\n            ...state.fields,\n            [e.target.id]: {\n              ...state.fields[e.target.id],\n              value: e.target.value,\n            },\n          },\n        })\n      }\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      Toggle,
      FormFieldMultipleInputs
    }} mdxType="Playground">
  <State initial={{
        fields: {
          41: {
            value: '',
            ariaLabel: 'Label 1',
            id: '41'
          },
          42: {
            value: '',
            ariaLabel: 'Label 2',
            id: '42'
          }
        }
      }} mdxType="State">
    {({
          state,
          setState
        }) => <FormFieldMultipleInputs {...state} helperText='Helper text' labelText='Label' onChange={e => setState({
          fields: { ...state.fields,
            [e.target.id]: { ...state.fields[e.target.id],
              value: e.target.value
            }
          }
        })} mdxType="FormFieldMultipleInputs" />}
  </State>
    </Playground>
    <hr />
    <h2 {...{
      "id": "multiple-input-fields-validation"
    }}>{`Multiple input fields (validation)`}</h2>
    <h3 {...{
      "id": "description-4"
    }}>{`Description`}</h3>
    <p>{`For multiple single lines of text, such as a mailing address.`}</p>
    <Playground __position={9} __code={'<State\n  initial={{\n    fields: {\n      51: {\n        error: \'required\',\n        value: \'\',\n        ariaLabel: \'Label 1\',\n        id: \'51\',\n      },\n      52: {\n        value: \'\',\n        ariaLabel: \'Label 2\',\n        id: \'52\',\n      },\n    },\n  }}\n>\n  {({ state, setState }) => (\n    <FormFieldMultipleInputs\n      {...state}\n      labelText=\"Label\"\n      notice=\"Notice\"\n      onChange={e =>\n        setState({\n          fields: {\n            ...state.fields,\n            [e.target.id]: {\n              ...state.fields[e.target.id],\n              value: e.target.value,\n            },\n          },\n        })\n      }\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      Toggle,
      FormFieldMultipleInputs
    }} mdxType="Playground">
  <State initial={{
        fields: {
          51: {
            error: 'required',
            value: '',
            ariaLabel: 'Label 1',
            id: '51'
          },
          52: {
            value: '',
            ariaLabel: 'Label 2',
            id: '52'
          }
        }
      }} mdxType="State">
    {({
          state,
          setState
        }) => <FormFieldMultipleInputs {...state} labelText='Label' notice='Notice' onChange={e => setState({
          fields: { ...state.fields,
            [e.target.id]: { ...state.fields[e.target.id],
              value: e.target.value
            }
          }
        })} mdxType="FormFieldMultipleInputs" />}
  </State>
    </Playground>
    <hr />
    <h2 {...{
      "id": "multiple-input-fields-disabled"
    }}>{`Multiple input fields (disabled)`}</h2>
    <h3 {...{
      "id": "description-5"
    }}>{`Description`}</h3>
    <p>{`For multiple single lines of text, such as a mailing address.`}</p>
    <Playground __position={11} __code={'<State\n  initial={{\n    fields: {\n      61: {\n        value: \'Text value\',\n        ariaLabel: \'Label 1\',\n        id: \'61\',\n        disabled: true,\n      },\n      62: {\n        value: \'Text value\',\n        ariaLabel: \'Label 2\',\n        id: \'62\',\n        disabled: true,\n      },\n    },\n  }}\n>\n  {({ state, setState }) => (\n    <FormFieldMultipleInputs\n      {...state}\n      labelText=\"Label\"\n      onChange={e =>\n        setState({\n          fields: {\n            ...state.fields,\n            [e.target.id]: {\n              ...state.fields[e.target.id],\n              value: e.target.value,\n            },\n          },\n        })\n      }\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      Toggle,
      FormFieldMultipleInputs
    }} mdxType="Playground">
  <State initial={{
        fields: {
          61: {
            value: 'Text value',
            ariaLabel: 'Label 1',
            id: '61',
            disabled: true
          },
          62: {
            value: 'Text value',
            ariaLabel: 'Label 2',
            id: '62',
            disabled: true
          }
        }
      }} mdxType="State">
    {({
          state,
          setState
        }) => <FormFieldMultipleInputs {...state} labelText='Label' onChange={e => setState({
          fields: { ...state.fields,
            [e.target.id]: { ...state.fields[e.target.id],
              value: e.target.value
            }
          }
        })} mdxType="FormFieldMultipleInputs" />}
  </State>
    </Playground>
    <hr />
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <Props of={FormFieldMultipleInputs} mdxType="Props" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;